/**
 * Shared password strength rules: minimum 8 characters with at least one
 * lowercase letter, one uppercase letter, one number and one special
 * character. Returns an error message for the first failed rule, or null
 * when the password satisfies all of them.
 */
export const validatePasswordStrength = (password: string): string | null => {
  if (password.length < 8) {
    return 'Password must be at least 8 characters long';
  }
  if (!/[a-z]/.test(password)) {
    return 'Password must contain at least one lowercase letter';
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }
  if (!/\d/.test(password)) {
    return 'Password must contain at least one number';
  }
  if (!/[!@#$%^&*]/.test(password)) {
    return 'Password must contain at least one special character (!@#$%^&*)';
  }
  return null;
};

export const PASSWORD_RULES_HINT =
  'Min 8 characters with one uppercase letter, one lowercase letter, one number and one special character (!@#$%^&*)';
